export const anchorCss = {
  outline: "none",
};
